import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  GetAllPersonsByUserResponse,
  IAuthAccessToken,
  IAuthLoginPayload
} from '../entities/authentication.interface';
import { APP_CONFIG, resolveOriginByConfig, resolveOriginsByConfig } from '@application/config';
import { IUserSettings } from '@shared/components/shortcuts/data-access';

@Injectable({providedIn: 'root'})
export class AuthService {
  private readonly http = inject(HttpClient);
  private readonly appConfig = inject(APP_CONFIG);
  private readonly apiUrl = this.appConfig.apiUrl;

  public login(payload: IAuthLoginPayload): Observable<IAuthAccessToken> {
    return this.http.post<IAuthAccessToken>(
        this.apiUrl.userService +
       '/Auth/Login',
      payload
    );
  }

  public refreshToken(payload: string): Observable<IAuthAccessToken> {
    const origin = resolveOriginByConfig(this.appConfig);
    
    return this.http.post<IAuthAccessToken>(
        this.apiUrl.userService +
       '/Auth/Refresh',
      {
        TokenId: payload,
        AppSource: origin,
      },
      {
        withCredentials: true,
      }
    );
  }

  public changePersonAccount(personId: string): Observable<IAuthAccessToken> {
    return this.http.post<IAuthAccessToken>(`${this.apiUrl.userService}/Auth/ChangePerson?personId=${personId}`, {},{
      withCredentials: true
    });
  }

  public getAllPersonsByUser(): Observable<GetAllPersonsByUserResponse[]> {
    const origins = resolveOriginsByConfig(this.appConfig);
    return this.http.get<GetAllPersonsByUserResponse[]>(`${this.apiUrl.userService}/UserProfile/GetAllPersonsByUser`,{
      params: { origins },
      withCredentials: true
    });
  }

  public getAllPersonsByAnotherUser(token: string): Observable<GetAllPersonsByUserResponse[]> {
    const origins = resolveOriginsByConfig(this.appConfig);
    return this.http.get<GetAllPersonsByUserResponse[]>(`${this.apiUrl.userService}/UserProfile/GetAllPersonsByUser`,{
      params: { origins },
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: false
    });
  }

  public loginByCodeTemp(payload : {sid: string, uid: string}): Observable<IAuthAccessToken> {
    return this.http.post<IAuthAccessToken>(`${this.apiUrl.userService}/Auth/LoginByCodeTemp`, payload, {
      withCredentials: false
    });
  }

  public getUserSettings(): Observable<IUserSettings> {
    return this.http.get<IUserSettings>(
      this.apiUrl.account_service + '/UserSettings/GetByPersonAsync', { 
        withCredentials: true
      }
    )
  }
}
